function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { SimpleEventEmitter } from "@sail/utils";
import PrefetchCache from "./PrefetchCache";
class EmitterPrefetchCache extends PrefetchCache {
    addItem(...args) {
        this._emitter.notify('addItem', args);
        return super.addItem(...args);
    }
    resolve(...args) {
        this._emitter.notify('resolve', args);
        return super.resolve(...args);
    }
    reject(...args) {
        this._emitter.notify('reject', args);
        return super.reject(...args);
    }
    addListener(listener) {
        this._emitter.addListener(listener);
    }
    constructor(...args){
        super(...args);
        _define_property(this, "_emitter", void 0);
        this._emitter = new SimpleEventEmitter();
    }
}
export { EmitterPrefetchCache as default };

//# sourceMappingURL=EmitterPrefetchCache.js.map